import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Revoke the workspace's Super Agent bot token without minting a replacement.
 * Any running orchestrator using it will stop authenticating until a new token
 * is generated and re-entered.
 */
const revokeSuperAgentToken = async (workspaceSlug: string): Promise<void> => {
  try {
    await AuthAxios.delete(`${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/super-agent/token`)
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('Enable AI for this workspace to manage the Super Agent token.')
    }
    throw error
  }
}

export default revokeSuperAgentToken
